package one.healthium.data.paywall.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.domain.paywall.models.Paywall

@Serializable
data class PaywallContainerDto(
    @SerialName("paywall") val paywall: Paywall,
)